import React from 'react';

import img1 from '../assests/img/partner-3.jpg';
import img2 from '../assests/img/partner-4.jpg';
import img3 from '../assests/img/partner-5.jpg';
import img4 from '../assests/img/partner-6.jpg';
import img5 from '../assests/img/partner-7.jpg';
import img6 from '../assests/img/partner-8.jpg';
import img7 from '../assests/img/partner-9.jpg';





function Faqhome() {
  return (
    <>

      <section className="show-activity partner-sec">

        <div className='sec-title'>
          <h2>Frequently Asked Questions (FAQ)</h2>
          <div class="separator"></div>
        </div>

        <div className='container'>
          <div className='row'>

            <div className='col-md-12 faq-content'>
                       <h3>Q1. What is the Jaipur Silver Show?</h3>
<p>The Jaipur Silver Show is India’s biggest B2B Silver Jewellery Exhibition organized by Aadikaash International, bringing together top silver jewellery brands and artisans.</p>
<h3>Q2. Who can participate in the Silver Show?</h3>
<p>Manufacturers, wholesalers, retailers, designers, and industry professionals from the silver jewellery sector can participate.</p>
<h3>Q3. When and where will the event take place?</h3>
<p>The show will be held in Jaipur, Rajasthan, at the Jaipur Exhibition Centre (dates will be announced on the official website).</p>
<h3>Q4. Why should I choose Aadikaash International?</h3>
<p>Aadikaash International has over a decade of experience in curating premium jewellery exhibitions and is committed to professionalism, growth, and industry excellence.</p>

            </div>         
          </div>
          </div>
         


       
      </section>

    </>
  )

}

export default Faqhome;
